module.exports = __webpack_public_path__ + "static/media/user.62557457.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/user.svg
// module id = 508
// module chunks = 0